module.exports = __webpack_public_path__ + "img/forth.31518443.png";